import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-mute.svg";
import * as styles from "./Icon.module.scss";

type MuteProps = React.SVGProps<SVGSVGElement>;

export const Mute = ({ className, ...props }: MuteProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
